import type {
  CollectionFilterPayload,
  CollectionResponseDto,
  FamilyStatesResponseDto,
} from "@/@types/price-markdown-selection";
import { Tags } from "@/enum/tags";
import { apiSlice } from "@/services/http";

import { withQueryString } from "./query-string";

export const priceMarkdownCollectionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCollection: builder.query<CollectionResponseDto, CollectionFilterPayload>({
      query: (filter) => {
        const params = new URLSearchParams();
        if (filter.family && filter.family.length > 0) {
          filter.family.forEach((f) => params.append("family", f));
        }
        if (filter.state && filter.state.length > 0) {
          filter.state.forEach((e) => params.append("state", e));
        }
        if (filter.cycle) params.set("cycle", filter.cycle);
        if (filter.cycleMonth) params.set("cycleMonth", filter.cycleMonth);
        if (filter.cycleFrom) params.set("cycleFrom", filter.cycleFrom);
        if (filter.cycleTo) params.set("cycleTo", filter.cycleTo);
        if (filter.currentCycleOnly) {
          params.set("currentCycleOnly", String(filter.currentCycleOnly));
        }
        if (filter.altered) {
          params.set("altered", String(filter.altered));
        }
        if (filter.orderBy) params.set("orderBy", filter.orderBy);
        if (filter.page !== undefined) {
          params.set("page", String(filter.page));
        }
        if (filter.perPage !== undefined) {
          params.set("perPage", String(filter.perPage));
        }
        return {
          url: withQueryString("/price-markdown/selection", params),
          method: "GET",
        };
      },
      providesTags: [Tags.PRICE_MARKDOWN_SELECAO],
    }),

    getFamilyStates: builder.query<FamilyStatesResponseDto, void>({
      query: () => ({
        url: "/price-markdown/selection/family-states",
        method: "GET",
      }),
      providesTags: [Tags.PRICE_MARKDOWN_SELECAO],
    }),
  }),
  overrideExisting: false,
});

export const { useGetCollectionQuery, useGetFamilyStatesQuery } =
  priceMarkdownCollectionApi;
